import momentJalaali from "moment-jalali";
import DatePicker from "react-datepicker2"
import { useForm } from "react-hook-form"
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { Button, Card, Col, FormGroup, Popover, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { useEffect, useRef, useState } from "react";
import { getVIPServiceList, changeVIPServiceStatus } from "../store/api/Services";
import { useDispatch, useSelector } from "react-redux";
import { CheckLg, ClockHistory, DashCircle, Envelope, List, PlusSquare, Search } from "react-bootstrap-icons";
import { checkMobile, keyIsLetterOrNumber, setErrorDialog } from "../../store/api/CommonFunctions";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ModalSendSMS from "../../Components/Modals/ModalSendSMS";
export default function VIPServices() {
    const tblResult = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const selectedRows = useRef([]);
    const [modalSMS, setModalSMS] = useState({ show: false });
    const serviceList = useSelector(state => state.service.vipServiceList?.Data);
    const currPostponeService = useRef({});
    const { handleSubmit, register } = useForm();
    const filterData = useRef({ Take: 0, Skip: 0 });
    const [selectedStaff, setStaffData] = useState();
    const [pending, setPending] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState();
    const [popSelectStaff, setPopStaff] = useState({ show: false });
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const popPostpone = (
        <Popover style={{ fontFamily: "Vazir" }}>
            <Popover.Title className="headerStyle">
                <ClockHistory size={18} />&nbsp;
                تعویق خدمت رسانی
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                <FormGroup className="mt-0">
                    <label>تاریخ خدمت رسانی بعدی:</label>
                    <DatePicker timePicker={false} isGregorian={false} className="form-control" onChange={value => currPostponeService.current.PostponeDate = value.local("en").format("YYYY-MM-DD HH:mm")} />
                </FormGroup>
                <Button variant="info" className="group-Btn mt-1" onClick={postponeService}><CheckLg size={17} />&nbsp; تعویق سرویس</Button>
            </Popover.Content>
        </Popover>
    )
    const tableCols = [
        { colTitle: "انتخاب", colName: "select", colType: "boolean", editable: true, onChange: selectRow, selectAll: selectAllRows },
        { colName: "RowNumber", colTitle: "ردیف", justInMobile: true },
        { colName: "PFirstContactDate", colTitle: "تاریخ پذیرش", justInMobile: true },
        { colName: "InvoiceNumber", colTitle: "شماره پذیرش" },
        { colName: "ProductName", colTitle: "نام محصول" },
        { colName: "ProductModel", colTitle: "مدل محصول" },
        { colName: "CustomerName", colTitle: "نام مشتری" },
        { colName: "CustomerMobile", colTitle: "شماره همراه" },
        { colName: "ServiceAddress", colTitle: "نشانی" },
        { colTitle: "", colName: "ServiceID", style: { display: "none" }, headerStyle: { display: "none" } },
        { colTitle: "", colName: "ServiceType", style: { display: "none" }, headerStyle: { display: "none" } }

    ]
    const rowButtons = [
        { title: "انصراف از خدمات", tooltip: "انصراف از خدمات", type: "common", className: "group-Btn-smalll btn-secondary", onclick: cancelVIPService, icon: <DashCircle size={16} color="red" /> },
        { title: "سرویس جدید", tooltip: "سرویس جدید", type: "common", className: "group-Btn-smalll", onclick: createNewSerivce, icon: <PlusSquare size={16} color="blue" /> },
        { title: "تعویض سرویس", tooltip: "تعویق سرویس", type: "overlay", overlay: popPostpone, className: "group-Btn-smalll btn-info", onclick: prepareForPostpone, icon: <ClockHistory size={16} color="green" /> },
    ]
    function cancelVIPService(row) {
        if (pending) {
            return;
        }
        setPending(true);
        const onCancel = (res) => {
            if (res !== "PENDING") {
                setPending(false);
            }
            if (res.Data) {
                setErrorDialog(dispatch, "success", "انصراف از خدمات");
                search({ ...filterData.current, Skip: 0 });
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "انصراف از خدمات");
            }
        }
        changeVIPServiceStatus(row.ServiceType, row.ServiceID, "cancel", null, onCancel);
    }
    function prepareForPostpone(row) {
        currPostponeService.current = row;
    }
    function postponeService() {
        if (pending) {
            return;
        }
        setPending(true);
        const onPostpone = (res) => {
            if (res !== "PENDING") {
                setPending(false);
            }
            if (res.Data) {
                setErrorDialog(dispatch, "success", "تعویق خدمت");
                search({ ...filterData.current, Skip: 0 });
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تعویض خدمت");
            }
        }
        changeVIPServiceStatus(currPostponeService.current.ServiceType, currPostponeService.current.ServiceID, "postpone", currPostponeService.current.PostponeDate, onPostpone);
    }
    function createNewSerivce(row) {
        if (pending) {
            return;
        }
        setPending(true);
        const onCreateNew = (res) => {
            if (res !== "PENDING") {
                setPending(false);
            }
            if (res.Data) {
                history.push(`/Services/Service/${res.Data}/repair`, null);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "خدمت جدید");
            }
        }
        changeVIPServiceStatus(row.ServiceType, row.ServiceID, "createnew", row.PostponeDate, onCreateNew);
    }
    function search(data) {
        data.Skip = 0;
        filterData.current = { ...data };
        dispatch(getVIPServiceList(data));
    }
    function showModalStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            setStaffData(data);

        }
        setPopStaff({ show: true, forAgency: true, onSelect: onSelect });
    }
    function showModalCustomer(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectCustomer = (data) => {
            setSelectedCustomer(data);
        }
        setPopCustomer({ show: true, value: e.key, invoiceCustomers: false, justForSelect: true, setCustomerData: onSelectCustomer });
    }
    function showService(row) {
        history.push(`/Services/Service/${row.ServiceID}/${row.ServiceType}`, null);
    }
    function selectRow(row) {
        const serviceID = Number(row.ServiceID);
        const serviceType = row.ServiceType;
        if (row.e.target.checked) {
            if (!selectedRows.current.some(r => r.ServiceID === serviceID && r.ServiceType === serviceType)) {
                selectedRows.current.push({ ServiceID: serviceID, ServiceType: serviceType });
            }
        }
        else {
            selectedRows.current = selectedRows.current.filter(r => r.ServiceID !== serviceID && r.ServiceType !== serviceType);
        }
    }
    function selectAllRows(e) {

        selectedRows.current = [];
        const table = e.target.closest("table");
        table.style.display = "none";
        for (let i = 1; i < table.rows.length; i++) {
            const row = table.rows[i];
            const srv = {};
            for (let j = 0; j < row.cells.length; j++) {
                if (row.cells[j]?.getAttribute("colname") === "select") {
                    const firstChild = row.cells[j].firstChild;
                    if (firstChild?.type === "checkbox") {
                        firstChild.checked = e.target.checked;
                    }
                }
                if (row.cells[j]?.getAttribute("colname") === "ServiceID") {
                    if (e.target.checked) {
                        const serviceID = Number(row.cells[j].firstChild.nodeValue);
                        if (serviceID > 0) {
                            srv.ServiceID = serviceID;
                        }
                    }
                }
                if (row.cells[j]?.getAttribute("colname") === "ServiceType") {
                    if (e.target.checked) {
                        const serviceType = row.cells[j].firstChild.nodeValue;
                        srv.ServiceType = serviceType;
                    }
                }
            }
            if (srv.ServiceID > 0) {
                selectedRows.current.push(srv);
            }
        }
        table.style.display = "table";
    }
    function showPopSMS() {
        const data = serviceList;
        const customerMobiles = [];
        const sendData = [];
        for (let i = 0; i < data.length; i++) {
            if (selectedRows.current.some(s => s.ServiceType === data[i].ServiceType && Number(s.ServiceID) === data[i].ServiceID)) {

                const mobiles = data[i].CustomerMobile?.split(',');
                if (mobiles) {
                    mobiles.forEach(m => {
                        if (checkMobile(m)) {
                            customerMobiles.push(m);
                        }
                    });
                    sendData.push({
                        Name: data[i].CustomerName,
                        ProductName: data[i].ProductName,
                        ProductModel: data[i].ProductModel,
                        MobileNumber: data[i].CustomerMobile,
                        ServiceNumber: data[i].InvoiceNumber,
                        ProductSerial: data[i].ProductSerial,
                        FirstContactDate: data[i].PFirstContactDate,
                        Address: data[i].ServiceAddress,
                        ServiceStatus: data[i].StatusName,
                        GuaranteeStartDate: data[i].GuaranteeStartDate?.length > 1 ? momentJalaali(data[i].GuaranteeStartDate).local("en").format("jYYYY/jMM/jDD") : "",
                        GuaranteeEndDate: data[i].GuaranteeEndDate?.length > 1 ? momentJalaali(data[i].GuaranteeEndDate).local("en").format("jYYYY/jMM/jDD") : ""

                    })
                }
            }
        }
        if (customerMobiles.length > 0)
            setModalSMS({
                show: true,
                sendData: sendData,
                to: customerMobiles.join(',')
            })
    }
    useEffect(() => {
        document.body.classList = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <ModalSelectStaff popData={popSelectStaff} setPopSelectStaff={setPopStaff} />
                <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
                <ModalSendSMS popData={modalSMS} setPopData={setModalSMS} /*templateType="services"*/ />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faClock} size="lg" />&nbsp;
                    سرویس های ویژه
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form readOnly onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder">
                            <Col md={2} className="form-group" >
                                <label>نوع سرویس: </label>
                                <select className="form-control" name="ServiceType" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="install">نصب</option>
                                    <option value="repair">تعمیر</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">
                                    <label> نام و کد مشتری </label>
                                </label>
                                <input type="hidden" name="CustomerID" ref={register({})} value={selectedCustomer?.ID ?? ""} readOnly />
                                <input placeholder='مشتری را انتخاب کنید' type="text" className="form-control" name="CustomerName" ref={register({})}
                                    value={(selectedCustomer?.Code ? (selectedCustomer.Code + "-") : "") + (selectedCustomer?.Name ?? "")} readOnly />
                                <Button className="btn-input-tiny" onClick={showModalCustomer}><List size={20} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نماینده:</label>
                                <input type='hidden' name="AgencyID" value={selectedStaff?.ID ?? ""} ref={register({})} readOnly />
                                <input placeholder='نماینده را انتخاب کنید' type="text" className='form-control' value={selectedStaff?.LastName ?? ""} readOnly />
                                <Button className="btn-input-tiny" onClick={showModalStaff} style={{ marginTop: "-1px" }}><List size={20} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه:</label>
                                <select className="form-control" name="Take" ref={register({})} defaultValue={10}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت انصراف:</label>
                                <select className="form-control" name="IsCanceled" ref={register({})} defaultValue={false}>
                                    <option value={true}>سرویس های انصرافی</option>
                                    <option value={false}>سایر سرویس ها</option>
                                </select>
                            </Col>
                        </Row>
                        <Button type="submit" className="group-Btn-large mt-1"><Search size={18} />&nbsp;نمایش فهرست</Button>
                        <Button variant="secondary" className="group-Btn-large mt-1" onClick={showPopSMS}><Envelope size={18} />&nbsp;ارسال پیامک</Button>
                    </form>
                    <BihamtaTable tableRef={tblResult} hasPaging={true} columns={tableCols} rowButtons={rowButtons} reducerName="service" objectName="vipServiceList" rowDoubleClikc={showService} filterData={filterData.current} searchMethod={(data) => dispatch(getVIPServiceList(data))} />
                </Card.Body>
            </Card>
        </div>
    )
}